import { render, staticRenderFns } from "./SelectSort.vue?vue&type=template&id=5765a535"
import script from "./SelectSort.vue?vue&type=script&lang=js"
export * from "./SelectSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports